import { styled } from "@mui/material";

import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import ButtonPolicy from "../components/Permission/ButtonPolicy";
import { setInputs } from "../util/generateInputs";
import { useNavigate, useNavigation } from "react-router-dom";
import { useEffect,useRef } from "react";

const useStyles = styled((theme) => {
  return {
    backButton: {
      marginRight: theme.spacing(1),
    },
    root: {
      display: "inline",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
    },
    field: {
      width: "30%",
      marginBottom: theme.spacing(2),
    },
  };
});

// const setInputs = (classes, inputs, errorMessages) => {
//   return Object.entries(inputs).map((element) => {
//     let width = element[1].multiline === undefined ? 4 : 12;
//     switch (element[1].type) {
//       case "text":
//         if (element[1].multiline) {
//           return (
//             <Grid key={element} item md={12}>
//               <div className="label">Info:</div>
//               <Box
//                 sx={{
//                   "& .MuiTextField-root": { m: 1, width: "200px" },
//                 }}
//               >
//                 <div className="multiLine">
//                   <TextField
//                     // placeholder="Enter your age"
//                     // label={element[0]}
//                     // id={element[0]}
//                     name={element[0]}
//                     // variant="outlined"
//                     multiline
//                     type={element[1].type}
//                     className={classes.field}
//                     value={element[1].value}
//                     onChange={element[1].valueChangeHandler}
//                     onBlur={element[1].inputBlurHandler}
//                     error={element[1].hasError}
//                     helperText={
//                       element[1].hasError && errorMessages[element[0]]
//                     }
//                   />
//                 </div>
//               </Box>
//             </Grid>
//           );
//         } else {
//           return (
//             <Grid key={element} item md={width}>
//               <div className="label">{element[0]}:</div>
//               {element[1].isPhone ? (
//                 <MuiTelInput
//                   name={element[0]}
//                   type={element[1].type}
//                   className={classes.field}
//                   value={element[1].value}
//                   onChange={(value, info) =>
//                     element[1].valueChangeHandler({
//                       type: "change",
//                       target: {
//                         value: value,
//                         type: element[1].type,
//                         name: element[0],
//                       },
//                     })
//                   }
//                   onBlur={(value, info) =>
//                     element[1].valueChangeHandler({
//                       type: "blur",
//                       target: {
//                         value: value,
//                         type: element[1].type,
//                         name: element[0],
//                       },
//                     })
//                   }
//                   error={element[1].hasError}
//                   helperText={element[1].hasError && errorMessages[element[0]]}
//                   defaultCountry="IT"
//                   preferredCountries={["IT"]}
//                   langOfCountryName="it"
//                 />
//               ) : (
//                 <TextField
//                   // placeholder="Enter your age"
//                   // label={element[0]}
//                   // id={element[0]}
//                   // variant="outlined"
//                   name={element[0]}
//                   type={element[1].type}
//                   className={classes.field}
//                   value={element[1].value}
//                   onChange={element[1].valueChangeHandler}
//                   onBlur={element[1].inputBlurHandler}
//                   error={element[1].hasError}
//                   helperText={element[1].hasError && errorMessages[element[0]]}
//                 />
//               )}
//             </Grid>
//           );
//         }
//       case "select":
//         return (
//           <Grid key={element} item md={width}>
//             <FormControl error={element[1].hasError}>
//               <div className="label">{element[0]}:</div>
//               <Select
//                 name={element[0]}
//                 className={classes.field}
//                 value={element[1].value}
//                 // onChange={}
//                 onBlur={(e) =>
//                   element[1].inputBlurHandler({
//                     type: "change",
//                     target: {
//                       value: e.target.value,
//                       type: e.target.type,
//                       name: e.target.name,
//                     },
//                   })
//                 }
//                 // error={element[1].hasError}
//                 // helperText={element[1].hasError && errorMessages[element[0]]}
//               >
//                 <MenuItem value=""></MenuItem>
//                 <MenuItem value={1}>Building in</MenuItem>
//               </Select>
//               {element[1].hasError && (
//                 <FormHelperText>errorMessages[element[0]]</FormHelperText>
//               )}
//             </FormControl>
//           </Grid>
//         );
//       case "checkbox":
//         return (
//           <Grid key={element} item md={width}>
//             <div className="label">{element[0]}:</div>
//             <Checkbox
//               checked={element[1].checked}
//               name={element[0]}
//               className={classes.field}
//               value={element[1].value}
//               onChange={element[1].valueChangeHandler}
//               // onBlur={element[1].inputBlurHandler}
//               error={element[1].hasError}
//               helperText={element[1].hasError && errorMessages[element[0]]}
//             />
//           </Grid>
//         );
//       case "switch":
//         return (
//           <Grid key={element} item md={width}>
//             <div className="label">{element[0]}:</div>
//             <Switch
//               checked={element[1].checked}
//               name={element[0]}
//               className={classes.field}
//               value={element[1].value}
//               onChange={element[1].valueChangeHandler}
//               // onBlur={element[1].inputBlurHandler}
//               error={element[1].hasError}
//               helperText={element[1].hasError && errorMessages[element[0]]}
//             />
//           </Grid>
//         );
//       default:
//         return "";
//     }
//   });
// };

const Form = (props) => {
  const {
    title,
    inputs,
    errorMessages,
    isValid,
    custom,
    hasError,
    activeStep,
    steps,
    onSubmit,
    externalSubmit,
    handleBack,
  } = props;
  const formRef = useRef(null);

  const navigate = useNavigate();
  const classes = useStyles();
  const inputsData = setInputs(classes, inputs, errorMessages);
  const hasSteps = !isNaN(steps);
  const navigation = useNavigation();
  // const [externalSubmit, setSubmit] = useState(externalSubmit);
  useEffect(() => {
    if (externalSubmit) {
      formRef.current?.dispatchEvent(new Event('submit',{ cancelable: true, bubbles: true }));
    }
  }, [externalSubmit]);

  const isSubmitting = navigation.state === "submitting";
  function cancelHandler() {
    navigate("..");
  }
  return (
    <div className="formContainer">
      <div className="newcTiltle">
        <h3>{title}</h3>
      </div>
      <form className={classes.root} ref={formRef} onSubmit={onSubmit}>
        <div className="partOne">
          <FormControl>
            <Grid container>{inputsData}</Grid>
            {props.children && <Grid container>{props.children}</Grid>}
          </FormControl>
        </div>
        {!custom && (
          <div>
            <ButtonPolicy
              type="button"
              disabled={isSubmitting}
              onClick={
                hasSteps && activeStep !== 0 ? handleBack : cancelHandler
              }
              className={classes.backButton}
            >
              Back
            </ButtonPolicy>
            <ButtonPolicy
              type="submit"
              disabled={(!isValid && hasError) || isSubmitting}
              variant="contained"
              color="primary"
            >
              {isSubmitting
                ? "Submitting..."
                : hasSteps
                ? activeStep === steps - 1
                  ? "Finish"
                  : "Next"
                : "Create"}
            </ButtonPolicy>
          </div>
        )}
      </form>
    </div>
  );
};
export default Form;
